import { useState, useEffect } from 'react';

const useSort = (initialData) => {
  const [sort, setSort] = useState({ dataIndex: 'billTime', order: 'desc' });
  const [sortData, setSortData] = useState(initialData);
  console.log({ initialData, sort });

  useEffect(() => {
    setSortData(() => {
      const newData = [...initialData];
      newData.sort((a, b) => {
        if (
          typeof a[sort.dataIndex] === 'number' ||
          typeof b[sort.dataIndex] === 'number'
        ) {
          if (sort.order === 'asc') {
            return a[sort.dataIndex] - b[sort.dataIndex];
          }
          return b[sort.dataIndex] - a[sort.dataIndex];
        }
        if (typeof a[sort.dataIndex] === 'string') {
          if (sort.order === 'asc') {
            return a[sort.dataIndex].localeCompare(b[sort.dataIndex]);
          }
          return b[sort.dataIndex].localeCompare(a[sort.dataIndex]);
        }
        return 0;
      });
      return newData;
    });
  }, [initialData, sort]);

  // const handleSort = useCallback((dataIndex, order) => {
  //   setSort({ dataIndex, order });
  //   setSortData((prevData) => {
  //     const newData = [...prevData];
  //     newData.sort((a, b) => {
  //       if (
  //         typeof a[dataIndex] === 'number' ||
  //         typeof b[dataIndex] === 'number'
  //       ) {
  //         if (order === 'asc') {
  //           return a[dataIndex] - b[dataIndex];
  //         }
  //         return b[dataIndex] - a[dataIndex];
  //       }
  //       if (typeof a[dataIndex] === 'string') {
  //         if (order === 'asc') {
  //           return a[dataIndex].localeCompare(b[dataIndex]);
  //         }
  //         return b[dataIndex].localeCompare(a[dataIndex]);
  //       }
  //       return 0;
  //     });
  //     return newData;
  //   });
  // }, []);

  return [sortData, sort, setSort];
};

export default useSort;
